export default "__VITE_ASSET__D_SJKASQ__"